/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select } from 'antd';
import React from 'react';
import './style.scss';

interface IOptions {
    id: number | string;
    value: number | string;
}

interface IProps {
    className?: string;
    placeholder?: string;
    defaultValue?: string;
    options?: IOptions[];
    disabled?: boolean;
    loading?: boolean;
    onChange?: (e: any) => void;
    width?: number | string;
    height?: number;
    field?: any;
    allowClear?: boolean;
    onClear?: () => void;
}

const SelectWrap: React.FC<IProps> = ({
    className,
    placeholder,
    defaultValue,
    options = [],
    disabled,
    loading,
    width,
    height,
    onChange,
    field,
    allowClear = false,
}) => {
    const newField = {
        placeholder,
        defaultValue,
        disabled,
        loading,
        ...field,
        ...(onChange && { onChange }),
    };
    return (
        <Select
            allowClear={allowClear}
            className={`${className} select__wrap`}
            style={{ height: height, width: width }}
            {...newField}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
            {options?.map((item: IOptions, key: number) => (
                <Select.Option key={key} value={item.id}>
                    {item.value}
                </Select.Option>
            ))}
        </Select>
    );
};

export default React.memo(SelectWrap);
